import React from 'react';

import { PrismicRichText } from '@prismicio/react';

import { Wrapper, Author } from './styles';

const Quote = ({ slice }) => (
  <Wrapper>
    <div>
      “<PrismicRichText field={slice.primary.description} />”
    </div>
    {slice.primary.author && <Author>{slice.primary.author}</Author>}
  </Wrapper>
);

export default Quote;
